import React from 'react'
import styles from './Dropdown.module.css'
import { Categories } from '../Navbar';

export type DropdownProps = {
    items: Categories[];
    isActive: boolean;
    setCurrentCategory: React.Dispatch<React.SetStateAction<null | number>>;
    setCurrentItem: React.Dispatch<React.SetStateAction<number>>;
    
}

const DropdownDB = (props: DropdownProps) => {
    return (
        <div className={`${styles.container} ${props.isActive && styles.active}`}>
            {props.items.map((item, index) => (
                <span key={index} onClick={() => { props.setCurrentCategory(item.ID); props.setCurrentItem(item.ID); }}>{item.Name}</span>
            ))}
        </div>
    )
}

export default DropdownDB
